var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2001 19.0583H13.0918C9.39176 19.0583 7.60843 17.6 7.30009 14.3333C7.26676 13.9917 7.51676 13.6833 7.86676 13.65C8.20009 13.6166 8.51676 13.875 8.55009 14.2167C8.79176 16.8333 10.0251 17.8083 13.1001 17.8083H13.2084C16.6001 17.8083 17.8001 16.6083 17.8001 13.2167V7.78332C17.8001 4.39165 16.6001 3.19165 13.2084 3.19165H13.1001C10.0084 3.19165 8.77509 4.18332 8.55009 6.84998C8.50843 7.19165 8.21676 7.44998 7.86676 7.41665C7.51676 7.39165 7.26676 7.08332 7.29176 6.74165C7.57509 3.42498 9.36676 1.94165 13.0918 1.94165H13.2001C17.2918 1.94165 19.0418 3.69165 19.0418 7.78332V13.2167C19.0418 17.3083 17.2918 19.0583 13.2001 19.0583Z",
    fill: "#ECE5E1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9999 11.125H3.5166C3.17493 11.125 2.8916 10.8417 2.8916 10.5C2.8916 10.1583 3.17493 9.875 3.5166 9.875H12.9999C13.3416 9.875 13.6249 10.1583 13.6249 10.5C13.6249 10.8417 13.3416 11.125 12.9999 11.125Z",
    fill: "#ECE5E1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.37503 13.9167C5.2167 13.9167 5.05837 13.8584 4.93337 13.7334L2.1417 10.9417C1.90003 10.7 1.90003 10.3 2.1417 10.0584L4.93337 7.2667C5.17503 7.02503 5.57503 7.02503 5.8167 7.2667C6.05837 7.50837 6.05837 7.90837 5.8167 8.15003L3.4667 10.5L5.8167 12.85C6.05837 13.0917 6.05837 13.4917 5.8167 13.7334C5.70003 13.8584 5.53337 13.9167 5.37503 13.9167Z",
    fill: "#ECE5E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.ebb07c2b6e58a77484712999a31856bc.svg";
export { ForwardRef as ReactComponent };